export const tr = {
    select: 'Seç',
    'zoom-in-button-text': 'Daha fazla'
};
